import classNames from 'classnames';
import { Link } from 'react-router-dom';
// import logo01 from './assets/logo02.png';
// import logo from './assets/logo.png';
import logo from './assets/logo.png';
import { useLogoStyles } from './LogoStyles';
// import { IndexRoutesConfig } from 'modules/minarioHome/Routes';

export const Logo = () => {
  const classes = useLogoStyles();
  return (
    <Link
      to={'/'}
      className={classes.root}
    >
      <img
        alt=""
        className={classNames(classes.img, classes.ableDark)}
        src={logo}
      />
      <img
        alt=""
        className={classNames(classes.img, classes.ableLight)}
        src={logo}
      />
      $Bitcoin
    </Link>
  );
};
